import { css } from 'emotion';

import { fonts } from '../../styles';

export const tooltipPaper = css`
  && {
    display: flex;
    flex-direction: column;
  }
  margin: 0 10px;
  padding: 15px;
  min-width: 150px;
`;

export const tooltipTitle = css`
  font-weight: ${fonts.weight.medium};
`;

export const subtitle = css`
  margin: 5px 0 15px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
`;
